import React, { useState, useEffect } from 'react';
import { configureEnvironment } from '../../infrastructure/config';

/**
 * Panel de configuración que permite cambiar entre usar la API real o los mocks
 */
const ConfigPanel: React.FC = () => {
  const [useRealApi, setUseRealApi] = useState<boolean>(
    localStorage.getItem('useRealApi') === 'true'
  );

  // Cuando cambia el estado, guardarlo en localStorage y configurar el entorno
  useEffect(() => {
    localStorage.setItem('useRealApi', useRealApi.toString());
    configureEnvironment(useRealApi);
  }, [useRealApi]);

  const handleToggleApiMode = () => {
    setUseRealApi(prev => !prev);
  };

  return (
    <div style={{ 
      padding: '10px', 
      background: '#f5f5f5', 
      borderRadius: '4px',
      marginBottom: '20px'
    }}>
      <h3 style={{ margin: '0 0 10px 0' }}>Configuración</h3>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label style={{ marginRight: '10px' }}>
          <input
            type="checkbox"
            checked={useRealApi}
            onChange={handleToggleApiMode}
          />
          Usar API real
        </label>
        <span style={{ 
          padding: '4px 8px', 
          borderRadius: '4px', 
          fontSize: '12px', 
          background: useRealApi ? '#4caf50' : '#ff9800',
          color: 'white'
        }}>
          {useRealApi ? 'API real' : 'Datos de prueba (Mock)'}
        </span>
      </div>
      <p style={{ margin: '10px 0 0 0', fontSize: '12px', color: '#666' }}>
        {useRealApi 
          ? 'Las peticiones se realizarán al servidor http://localhost:3000' 
          : 'Se utilizarán datos de prueba locales'}
      </p>
    </div>
  );
};

export default ConfigPanel; 